import React from 'react';

type ChoosePlanHeaderProps = {
  description?: string;
};

const ChoosePlanHeader = ({ description }: ChoosePlanHeaderProps) => {
  return (
    <div className="mb-32 text-center sm:mb-48">
      <h1 className="font-suisse-works mb-16 mt-0 text-headline-md xs:text-headline-lg sm:text-headline-lg">
        Choose the plan that’s right for you
      </h1>
      <h3 className="font-suisse-neue m-0 mx-auto max-w-[565px] text-body-lg xs:text-[16px]">
        {description ||
          'The Information is first to the news that matters in tech and finance—so our audience of leaders stays ahead and informed to make decisions that matter.'}
      </h3>
    </div>
  );
};

export default ChoosePlanHeader;
